import "../styles/app.scss";
import "../node_modules/@splidejs/splide/dist/css/splide.min.css";

import Splide from "@splidejs/splide";
import { toggle } from "./toggle/toggle.js";
import { cookiePolicy } from "./cookiepolicy/cookiepolicy.js";
import { multilevel } from "./multilevel-nav/multilevel-nav.js";
import { windowheight } from "./windowheight/windowheight.js";
import { scrollanimation } from "./scrollanimation/scrollanimation.js";

var elemental = require("./elem/elem.js");
let CookiesEuBanner = new cookiePolicy();
let Multilevel = new multilevel(".menu");
var scrollAni = new scrollanimation(document.querySelectorAll(".animate__me"));

// Set up Toggles
let toggleNavicon = new toggle(
  "data-linknavicon",
  "data-targetnavicon",
  "active"
);

// Navigation Overlay Control
let mvo = document.querySelectorAll(".molecule-navigation-overlay");

mvo.forEach((elem) => {
  elem.addEventListener("click", (e) => {
    e.preventDefault();
    document
      .querySelectorAll(".molecule-navigation, .atom-navicon, body")
      .forEach((a) => {
        a.classList.remove("active");
        document.body.classList.remove("no-scroll");
      });
  });
});

// Identify window height and add class to body
let WindowHeight = new windowheight();

export function main() {
  return console.log("Javascript Started");
}

/* Uses .inherit-link to scan for the first link it finds. This makes a div with a link inside clickable */
function inheritLinks() {
  var inheritLinks = document.querySelectorAll(
    ".inherit-link, .bounce-inherit-link"
  );

  let i;
  inheritLinks.forEach(function (links) {
    if (!links.classList.contains("disable__link")) {
      // Search for parent node

      if (links.classList.contains("bounce-inherit-link")) {
        links = links.parentNode;
      }

      // Loop around click event, get ref and redirect window
      links.addEventListener("click", function () {
        let getLink = links.querySelector("a");

        // Identify _blank
        window.location.href = getLink.href;
      });
    }
  });
}

inheritLinks();

// Change Logo on scroll
logoChangeOnScroll();

function logoChangeOnScroll() {
  let logo = document.querySelector(".atom-logo");
  let navBarElem = document.querySelector(".header-bar-elements");

  window.addEventListener("scroll", () => {
    let elemY = window.scrollY;

    if (elemY >= 150) {
      if (!logo.classList.contains("small-logo")) {
        logo.classList.add("small-logo");
        navBarElem.classList.add("header-bar-small");
      }
    } else {
      if (logo.classList.contains("small-logo")) {
        logo.classList.remove("small-logo");
        logo.classList.add("atom-logo");
        navBarElem.classList.remove("header-bar-small");
      }
    }
  });
}

// Change navbar styling with Header Banner Block
let headerBannerBlock = document.querySelector(".header-banner-block");
let navBar = document.querySelector(".header-bar");
let navBarInner = document.querySelector(".header-bar-elements");
let navBarWrapper = document.querySelector(".header-bar-wrapper");
let siteLogo = document.querySelector(".atom-logo");
let menuIcon = document.querySelector(".navicon");
let homePage = document.querySelector(".home");
let pageWidth = window.innerWidth;

navBarScrollTransform();

function navBarScrollTransform() {
  window.addEventListener("scroll", () => {
    let elemY = window.scrollY;

    if (headerBannerBlock) {
      if (elemY >= headerBannerBlock.offsetHeight) {
        navBar.classList.remove("relative");
        navBar.style.height = "130";
        navBarInner.classList.add(
          "bx-default",
          "p-fixed",
          "bg-white",
          "header-bar-small"
        );
        navBarInner.classList.remove("pt-50");
        menuIcon.classList.remove("header-banner-block-navicon");
        navBarWrapper.classList.add("align-items-center");

        if (homePage) {
          siteLogo.classList.remove("header-banner-block-big-logo");
        } else {
          siteLogo.classList.remove("header-banner-block-small-logo");
        }
      } else {
        navBarTransformClass();
      }
    }
  });
}

navBarTransformClass();

function navBarTransformClass() {
  if (headerBannerBlock && pageWidth > 561) {
    // Re-style the navbar and the block
    navBar.style.height = "0";
    navBarInner.classList.remove("bx-default", "p-fixed", "bg-white");
    navBarInner.classList.add("pt-50");
    menuIcon.classList.add("header-banner-block-navicon");
    navBarWrapper.classList.remove("align-items-center");

    if (homePage) {
      siteLogo.classList.add("header-banner-block-big-logo");
    } else {
      siteLogo.classList.add("header-banner-block-small-logo");
    }
  }
}

// Create Accordion tabs for mobile
createAccordionElems();

function createAccordionElems() {
  let accordionTabHTML;
  let accordionPanelHTML;
  let textElems = document.querySelectorAll(
    ".image-three-column-text-block .three-columns .atom-text-field"
  );

  if (textElems) {
    textElems.forEach((textElem) => {
      // Create div to hold elems
      accordionTabHTML = document.createElement("div");
      accordionTabHTML.classList.add("accordion-tab");
      accordionPanelHTML = document.createElement("div");
      accordionPanelHTML.classList.add("accordion-panel");
      textElem.appendChild(accordionTabHTML);
      textElem.appendChild(accordionPanelHTML);

      // Make sure the accordionTabHTML is at the top and gets the first elem
      textElem
        .querySelectorAll(".three-columns .atom-text-field > p:first-child")
        .forEach((elem) => {
          textElem.insertBefore(accordionTabHTML, textElem.firstChild);
          textElem.insertBefore(accordionPanelHTML, accordionTabHTML);
          injectElem(".accordion-tab", elem);
        });
      // Make sure accordionPanelHTML
      textElem
        .querySelectorAll(".three-columns .atom-text-field > p:nth-child(n+2)")
        .forEach((elem2) => {
          textElem.insertBefore(accordionPanelHTML, textElem.secondChild);
          injectElem(".accordion-panel", elem2);
        });
    });
  }
}

function injectElem(moveTo, toMove) {
  let injector = document.querySelectorAll(moveTo);

  injector.forEach((inject) => {
    let findColumns = inject.closest('[data-type="organism"]');
    let source = "";

    if (!toMove.nodeType) {
      source = findColumns.querySelector(toMove);
    } else {
      source = toMove;
    }

    inject.appendChild(source);
  });
}

//Accordion Functionality
accordionInit();

function accordionInit() {
  let accordionBtns = document.querySelectorAll(".accordion-tab");
  let accordionsPanels = document.querySelectorAll(".accordion-panel");

  // Hide all accordionsPanels content except for first
  accordionsPanels.forEach((accordionsPanel, index) => {
    if (index == 0) {
      accordionsPanel.classList.add("open");
    }
  });

  accordionBtns.forEach((accordion, index) => {
    if (index == 0) {
      accordion.classList.add("open");
    }

    accordion.onclick = function () {
      let content = this.nextElementSibling;

      if (!content.classList.contains("open")) {
        content.classList.add("open");
        accordion.classList.add("open");
      } else {
        content.classList.remove("open");
        accordion.classList.remove("open");
      }
    };
  });
}

// Team Slider
if (document.querySelector(".splide-team-member") && pageWidth <= 600) {
  document.addEventListener("DOMContentLoaded", function () {

    let splide = [];

    document.querySelectorAll(".splide-team-member").forEach((elem, i) => {
       splide[i] = new Splide(elem, {
        type: "loop",
        perPage: 1,
        perMove: 1,
      }).mount();

      // Select and assign slider no of slide count
      splide[i].root.querySelector(".count1").innerHTML = "1";
      splide[i].root.querySelector(".count2").innerHTML = splide[i].length;

      // Update on click right arrow
      splide[i].root.querySelector(".tabRight").addEventListener("click", () => {
        splide[i].go("+");
      });
      // Update on click left arrow
      splide[i].root.querySelector(".tabLeft").addEventListener("click", () => {
        splide[i].go("-");
      });
      // Update count
      splide[i].on("moved", function () {
        splide[i].root.querySelector(".count1").innerHTML = splide[i].index + 1;
      });
    });
  });
}

// Featured Developments Slider
if (document.querySelector(".splide-featured-development")) {
  document.addEventListener("DOMContentLoaded", function () {
    let splide = new Splide(".splide-featured-development", {
      type: "loop",
      perPage: 1,
      perMove: 1,
      autoplay: true,
    }).mount();

    // Progress Bar
    let progressBar = document.querySelector("#progress");

    // Select and assign slider no of slide count
    splide.root.querySelector(".count1").innerHTML = "1";
    splide.root.querySelector(".count2").innerHTML = splide.length;

    // Slider Progress Bar init val
    progressBar.style.width = (100 / splide.length) * 1 + "%";

    // Update on click right arrow
    splide.root.querySelector(".tabRight").addEventListener("click", () => {
      splide.go("+");
    });
    // Update on click left arrow
    splide.root.querySelector(".tabLeft").addEventListener("click", () => {
      splide.go("-");
    });

    // Update count
    splide.on("moved", function () {
      splide.root.querySelector(".count1").innerHTML = splide.index + 1;
      progressBar.style.width =
        100 / (splide.length / (splide.index + 1)) + "%";
    });
  });
}

// Newsletter form functionality
newsletterInit();

function newsletterInit() {
  let newsletterBtns = document.querySelectorAll(".newsletter-btn");
  let modal = document.querySelector(".molecule-modal-popup");
  let closeModalBtn = document.querySelector(".modal-close-btn");
  let overlayBlur = document.querySelector(".overlay-blur");

  newsletterBtns.forEach((newsletterBtn) => {
    // Show the form
    newsletterBtn.addEventListener("click", (e) => {
      e.preventDefault();
      modal.classList.add("active");
      document.body.classList.add("no-scroll");
      overlayBlur.classList.add("blur");
    });
  });

  closeModalBtn.addEventListener("click", () => {
    modal.classList.remove("active");
    document.body.classList.remove("no-scroll");
    overlayBlur.classList.remove("blur");
  });
}

// Get map and pin values
function retrieveMapValues(mapType, id) {
  let lat = document.querySelector(mapType + " [data-lat]");
  let long = document.querySelector(mapType + " [data-long]");

  if (!lat.dataset.lat) {
    return [-72.2218047, 21.7926974];
  }

  if (!long.dataset.long) {
    return [-72.2218047, 21.7926974];
  }
  return [long.dataset.long, lat.dataset.lat];
}

// Map
if (document.getElementById("contact-us-map")) {
  mapboxgl.accessToken =
    "pk.eyJ1IjoiZXJoLTEyIiwiYSI6ImNrbnp6Zjc1ODBhb3gydms0Nm43ODdpcXYifQ.wru_8TLKTbi7-KFVQkUuZw";

  let startingZoom = 12;

  if (window.innerWidth < 960) {
    startingZoom = 10;
  }

  var map = new mapboxgl.Map({
    container: "contact-us-map",
    style: "mapbox://styles/erh-12/ckuqrgka5axey17s0s9wdbkec", // stylesheet location
    center: retrieveMapValues('[data-pos="map"]'), // starting position [lng, lat]
    zoom: startingZoom, // starting zoom
    interactive: false,
  });

  var geojson = {
    type: "Offices",
    features: [
      {
        type: "The Office",
        properties: {
          message: "Foo",
          iconSize: [60, 60],
        },
        geometry: {
          type: "Point",
          coordinates: retrieveMapValues('[data-pos="pin-1"]'),
        },
      },
      {
        type: "South Bank",
        properties: {
          message: "Foo",
          iconSize: [60, 60],
        },
        geometry: {
          type: "Point",
          coordinates: retrieveMapValues('[data-pos="pin-2"]'),
        },
      },
      {
        type: "Emerald Estate",
        properties: {
          message: "Foo",
          iconSize: [60, 60],
        },
        geometry: {
          type: "Point",
          coordinates: retrieveMapValues('[data-pos="pin-3"]'),
        },
      },
      {
        type: "Blue Cay Estate",
        properties: {
          message: "Foo",
          iconSize: [60, 60],
        },
        geometry: {
          type: "Point",
          coordinates: retrieveMapValues('[data-pos="pin-4"]'),
        },
      },
      {
        type: "Niva At South Bank",
        properties: {
          message: "Foo",
          iconSize: [60, 60],
        },
        geometry: {
          type: "Point",
          coordinates: retrieveMapValues('[data-pos="pin-5"]'),
        },
      },
    ],
  };

  var nav = new mapboxgl.NavigationControl({
    showCompass: false,
  });
  map.addControl(nav, "bottom-left");
  map.scrollZoom.disable();
  map.dragPan.enable();
  if (map.tap) map.tap.disable();

  geojson.features.forEach(function (marker, i) {
    // create a DOM element for the marker
    var el = document.createElement("div");
    el.classList.add("marker", "marker" + i);

    // add marker to map
    new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
  });
}

mapFunctionalityInit();

function mapFunctionalityInit() {
  let offices = document.querySelectorAll(".location-wrapper");
  let pinMapMarkers = document.querySelectorAll(".marker");

  offices.forEach((office, i) => {
    // Click On The Office Address
    office.addEventListener("click", () => {
      //Pin Markers
      pinMapMarkers.forEach((pinMapMarker) => {
        if (pinMapMarker.classList.contains("inactive")) {
          pinMapMarker.classList.remove("inactive");
          pinMapMarker.classList.add("active");
        } else {
          pinMapMarker.classList.toggle("active");
          pinMapMarker.classList.remove("inactive");
        }

        // Index start at 0
        let markerSiblings = getSiblings(document.querySelector(".marker" + i));

        markerSiblings.forEach((sibling) => {
          if (
            sibling.classList.contains("active") &&
            sibling.classList.contains("marker")
          ) {
            sibling.classList.remove("active");
            sibling.classList.add("inactive");
          }

          if (
            !sibling.classList.contains("inactive") &&
            sibling.classList.contains("marker")
          ) {
            sibling.classList.add("inactive");
          }
        });
      });

      // Locations Offices
      if (office.classList.contains("inactive")) {
        office.classList.remove("inactive");
        office.classList.add("active");
      } else {
        office.classList.toggle("active");
        office.classList.remove("inactive");
      }

      let officeSiblings = getSiblings(office);

      officeSiblings.forEach((sibling) => {
        if (sibling.classList.contains("active")) {
          sibling.classList.remove("active");
          sibling.classList.add("inactive");
        }

        if (!sibling.classList.contains("inactive")) {
          sibling.classList.add("inactive");
        }
      });
    });
  });

  pinMapMarkers.forEach((pinMapMarker, i) => {
    // Click On The Pin Map Marker
    pinMapMarker.addEventListener("click", () => {
      if (pinMapMarker.classList.contains("inactive")) {
        pinMapMarker.classList.remove("inactive");
        pinMapMarker.classList.add("active");
      } else {
        pinMapMarker.classList.toggle("active");
        pinMapMarker.classList.remove("inactive");
      }

      let markerSiblings = getSiblings(pinMapMarker);

      markerSiblings.forEach((sibling) => {
        if (
          sibling.classList.contains("active") &&
          sibling.classList.contains("marker")
        ) {
          sibling.classList.remove("active");
          sibling.classList.add("inactive");
        }

        if (
          !sibling.classList.contains("inactive") &&
          sibling.classList.contains("marker")
        ) {
          sibling.classList.add("inactive");
        }
      });

      offices.forEach((office) => {
        // Locations Offices
        if (office.classList.contains("inactive")) {
          office.classList.remove("inactive");
          office.classList.add("active");
        } else {
          office.classList.toggle("active");
          office.classList.remove("inactive");
        }

        // Index start at 1
        let officeSiblings = getSiblings(
          document.querySelector(".location-" + (i + 1))
        );

        officeSiblings.forEach((sibling) => {
          if (sibling.classList.contains("active")) {
            sibling.classList.remove("active");
            sibling.classList.add("inactive");
          }

          if (!sibling.classList.contains("inactive")) {
            sibling.classList.add("inactive");
          }
        });
      });
    });
  });
}

function getSiblings(node) {
  let targetSiblings = [...node.parentNode.children].filter((c) => c !== node);
  return targetSiblings;
}
